import {LegalDocumentPage} from 'attendee/LegalDocumentPage'
import React from 'react'
import {routes} from 'routes/routes'

export function TermsAndConditions() {
  return (
    <LegalDocumentPage
      slug="terms"
      routePath={routes.terms}
      i18nPrefix="legal.terms"
    />
  )
}
